"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var field_validation_errors_1 = require("./field-validation-errors");
var label_1 = require("./label");
var CheckboxList = function (props) {
  var field = props.field,
    items = props.field.model.items,
    value = props.value,
    onChange = props.onChange,
    errors = props.errors,
    tracker = props.tracker;
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(label_1.Label, __assign({}, props)), items.map(function (item, index) {
    return react_1.default.createElement("label", {
      key: item.itemId
    }, react_1.default.createElement("input", {
      type: "checkbox",
      className: field.model.cssClass,
      id: field.valueField.id + index,
      name: field.valueField.name,
      value: item.value,
      checked: value.some(function (v) {
        return v === item.value;
      }),
      onChange: function (e) {
        return handleOnChange(field, value, e.target.value, e.target.checked, onChange);
      },
      onFocus: function () {
        return tracker.onFocusField(field, value);
      },
      onBlur: function () {
        return tracker.onBlurField(field, value, errors);
      }
    }), item.text);
  }), react_1.default.createElement(field_validation_errors_1.FieldValidationErrors, __assign({}, props)));
};
function handleOnChange(field, originalFieldValue, changedElement, checked, callback) {
  // we can have multiple selected values. So we need to push ALL the selected
  // values back up to the root form. This is done using an array, which the form
  // serializer knows how to expand into multiple values on post
  var value = originalFieldValue;
  if (checked) {
    value.push(changedElement);
  } else {
    value = value.filter(function (v) {
      return v !== changedElement;
    });
  }
  // (fieldName, fieldValue, isValid, validationErrors)
  callback(field.valueField.name, value, true, []);
}
exports.default = CheckboxList;